const localPorts = require('../../localPorts.config').localPorts;


module.exports = {
    API: `http://localhost:${localPorts['developer-portal']}/api`,
    CDN: `http://localhost:${localPorts['developer-portal']}`,
    // API: 'https://www.r1s-dev.com/api',
    // CDN: 'https://cdn.r1s-dev.com/app',
    LD_USER_KEY: 'f47728b4-2541-5f90-b7f5-e0a5086c6c72',
    LD_ENV_KEY: '588a570044b03e0b32112cfc',
    NODE_ENV: 'development',
    REACT_AXE_ENABLED: true,
    SENTRY_CONFIG_URL: 'https://551530989e934bceacf37321c9d8bb9c@sentry.io/1137789'
};
